import {
 bexoHttpClient
} from '../../clients';
import {
 BeXActionCreateRecordsResponse,BeXActionUpdateRecordsResponse,BeXActionDeleteUserResponse, DeleteUserResponse
} from './Types/Bexo.types';

/**
 * Service class for performing Create/Update/Delete operations related to BeX Actions.
 */
class BeXActionService {

    /**
     * Creates records.
     * @param {string} oragID - The ID of the tenant to create records for.
     * @param {string} appId - The ID of the app to create records for.
     * @param {object} payload - The request payload containing the details for the BeX action.
     * @returns {Promise<any>} The response from the server after inserting the BeX action.
     */
    async createRecords(oragID: string, appId: string, payload: object): Promise<BeXActionCreateRecordsResponse> {
        const response = await bexoHttpClient.post('/actions/bex-action', payload, {
            params: {
                org_id: oragID,
                app_id: appId,
            },
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response.data;
    }

    /**
     * Updates records.
     * @param {string} oragID - The ID of the tenant to update records for.
     * @param {string} appId - The ID of the app to update records for.
     * @param {object} payload - The request payload containing the details for the BeX action.
     * @returns {Promise<any>} The response from the server after updating the BeX action.
     */
    async updateRecords(oragID: string, appId: string, payload: object): Promise<BeXActionUpdateRecordsResponse> {
        const response = await bexoHttpClient.post('/actions/bex-action', payload, {
            params: {
                org_id: oragID,
                app_id: appId,
            },
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response.data;
    }

    /**
     * Deletes records.
     * @param {string} oragID - The ID of the tenant to delete records for.
     * @param {string} appId - The ID of the app to delete records for.
     * @param {object} payload - The request payload containing the details for the BeX action.
     * @returns {Promise<any>} The response from the server after deleting the BeX action.
     */
    async deleteRecords(oragID: string, appId: string, payload: object): Promise<BeXActionDeleteUserResponse> {
        const response = await bexoHttpClient.post('/actions/bex-action', payload, {
            params: {
                org_id: oragID,
                app_id: appId,
            },
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response.data;
    }

    /**
     * Deletes a user.
     * @param {string} tenantId - The ID of the tenant to delete the user from.
     * @param {string} appId - The ID of the app to delete the user from.
     * @param {string} email - The email of the user to delete.
     * @returns {Promise<any>} The response from the server after deleting the user.
     */
    async deleteUser(tenantId: string, appId: string, email: string): Promise<DeleteUserResponse> {
        const url = `/api/v1/users/${tenantId}/${appId}/${encodeURIComponent(email)}`;

        const response = await bexoHttpClient.delete(url, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response.data;
    }
}

const bexActionService = new BeXActionService();
export { bexActionService };
